import { useQuery } from '@tanstack/react-query';

import { handleErrorResponse } from '../../utils/handleError';

import { fetchMedicationReminders } from '../../apis/medication';
import { useAppSelector } from '../../redux/hooks';

const useFetchMedicationReminders = (patientId: number) => {
  const authData = useAppSelector((state) => state.auth);
  const timeZone = authData?.constants?.timezone;

  const { data, isError, isLoading, isRefetching, error } = useQuery({
    queryKey: ['medication-reminder-list'],
    queryFn: () => fetchMedicationReminders(patientId, timeZone),
  });

  if (isError) {
    handleErrorResponse(error, 'Error Fetching Medication Reminders');
  }

  return {
    isLoading,
    isError,
    isRefetching,
    medicationReminders: data || [],
  };
};

export default useFetchMedicationReminders;
